<template>
  <v-dialog v-model="value" max-width="600" persistent>
    <v-card class="elevation-12 rounded-lg">
      <v-card-title class="headline primary white--text d-flex justify-space-between align-center py-3">
        <div>
          <v-icon color="white" class="mr-2">star</v-icon>
          <span>Avaliações do Frentista</span>
          <span v-if="frentista" class="font-weight-bold"> - {{ frentista.nome }}</span>
        </div>
        <v-btn icon dark class="ma-0" @click="fechar">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Seção de Filtros -->
      <v-card-text class="grey lighten-4 py-2 px-3">
        <v-layout row wrap align-center>
          <v-flex xs12 sm5 class="px-2">
            <v-select
              v-model="filtroNota"
              :items="opcoesNota"
              label="Filtrar por Nota"
              hide-details
              dense
              class="pt-0"
              @change="buscarNovamente"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm5 class="px-2">
            <v-text-field
              v-model="filtroData"
              type="date"
              label="Filtrar por Data"
              hide-details
              dense
              class="pt-0"
              @change="buscarNovamente"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm2 class="text-xs-center text-sm-right px-2 pt-2 pt-sm-0">
            <v-btn icon @click="limparFiltros" title="Limpar Filtros" class="ma-0">
              <v-icon color="red lighten-1">clear_all</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-text class="pa-4">
        <!-- Loading State -->
        <div v-if="carregando" class="text-xs-center py-5">
          <v-progress-circular indeterminate color="primary" size="48" width="4"></v-progress-circular>
          <p class="mt-3 grey--text font-weight-medium">Carregando avaliações...</p>
        </div>

        <div v-else-if="avaliacoes && avaliacoes.length > 0">
          <div v-for="avaliacao in avaliacoes" :key="avaliacao.id">
            <v-card flat class="mb-3 pa-3" style="border: 1px solid #e0e0e0; border-radius: 8px; background: #fff;">
              <v-layout row wrap align-center justify-space-between>
                <v-flex xs12 sm8>
                  <v-layout align-center>
                    <v-rating
                      :value="avaliacao.nota || 0"
                      color="amber"
                      background-color="grey lighten-1"
                      dense
                      readonly
                      size="18"
                    ></v-rating>
                    <span class="ml-2 font-weight-bold grey--text text--darken-2">({{ avaliacao.nota || 0 }} / 5)</span>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm4 class="text-xs-left text-sm-right mt-1 mt-sm-0">
                  <span class="caption grey--text font-weight-medium">{{ formatarData(avaliacao.data_avaliacao) }}</span>
                </v-flex>
              </v-layout>

              <div v-if="avaliacao.comentario" class="mt-2 pa-2 grey lighten-5" style="border-left: 3px solid #1976D2; font-style: italic; border-radius: 0 4px 4px 0; color: #424242; font-size: 13px;">
                "{{ avaliacao.comentario }}"
              </div>
              <div v-else class="mt-2 grey--text text--lighten-1 caption italic">
                Sem comentário.
              </div>

              <v-layout align-center class="mt-2" v-if="avaliacao.compra">
                <v-chip label small color="blue-grey lighten-5" class="ma-0" text-color="blue-grey darken-3" style="font-size: 11px;">
                  <v-icon left size="12">shopping_cart</v-icon>
                  Compra ID: #{{ avaliacao.compra }}
                </v-chip>
              </v-layout>
            </v-card>
          </div>

          <!-- Pagination Footer -->
          <v-layout row align-center justify-space-between class="mt-4 pt-2" style="border-top: 1px solid #eee;">
            <v-btn
              flat
              color="primary"
              class="ma-0"
              :disabled="!temAnterior || carregando"
              @click="irParaPagina(page - 1)"
            >
              <v-icon left>navigate_before</v-icon>
              Anterior
            </v-btn>
            <span class="body-2 grey--text text--darken-1">Página {{ page }} de {{ totalPages || 1 }}</span>
            <v-btn
              flat
              color="primary"
              class="ma-0"
              :disabled="!temProximo || carregando"
              @click="irParaPagina(page + 1)"
            >
              Próximo
              <v-icon right>navigate_next</v-icon>
            </v-btn>
          </v-layout>
        </div>

        <!-- Empty State -->
        <div v-else class="text-xs-center py-5 grey--text">
          <v-icon size="48" class="mb-3" color="grey lighten-1">rate_review</v-icon>
          <p class="subheading font-weight-medium">Nenhuma avaliação encontrada.</p>
        </div>
      </v-card-text>

      <v-card-actions class="pa-3 grey lighten-4">
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" flat @click="fechar">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogAvaliacaoFrentista',
  props: {
    value: Boolean,
    frentista: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      avaliacoes: [],
      carregando: false,
      page: 1,
      total: 0,
      temProximo: false,
      temAnterior: false,
      filtroNota: null,
      filtroData: '',
      opcoesNota: [
        { text: 'Todas as notas', value: null },
        { text: '5 Estrelas', value: 5 },
        { text: '4 Estrelas', value: 4 },
        { text: '3 Estrelas', value: 3 },
        { text: '2 Estrelas', value: 2 },
        { text: '1 Estrela', value: 1 }
      ]
    }
  },
  computed: {
    totalPages () {
      return Math.ceil(this.total / 5) || 1
    }
  },
  watch: {
    value (newVal) {
      if (newVal) {
        this.limparFiltrosSilent()
        this.carregarDados()
      }
    }
  },
  methods: {
    fechar () {
      this.$emit('input', false)
    },
    async carregarDados () {
      if (!this.frentista) return

      this.carregando = true
      try {
        const params = {
          page: this.page
        }
        if (this.filtroNota !== null) {
          params.nota = this.filtroNota
        }
        if (this.filtroData) {
          params.data = this.filtroData
        }

        const res = await this.$store.dispatch('buscarAvaliacoesFrentista', {
          frentista: this.frentista,
          params
        })

        if (res && res.results) {
          // Trata os dados localmente garantindo que campos nulos não quebrem a renderização
          this.avaliacoes = res.results.map(item => ({
            id: item.id || Math.random().toString(),
            nota: item.nota !== null && item.nota !== undefined ? Number(item.nota) : 0,
            comentario: item.comentario || '',
            data_avaliacao: item.data_avaliacao || '',
            compra: item.compra || null
          }))
          this.total = res.count || 0
          this.temProximo = !!res.next
          this.temAnterior = !!res.previous
        } else {
          // Tratamento fallback caso a paginação venha em formato diferente
          const lista = Array.isArray(res) ? res : []
          this.avaliacoes = lista.map(item => ({
            id: item.id || Math.random().toString(),
            nota: item.nota !== null && item.nota !== undefined ? Number(item.nota) : 0,
            comentario: item.comentario || '',
            data_avaliacao: item.data_avaliacao || '',
            compra: item.compra || null
          }))
          this.total = this.avaliacoes.length
          this.temProximo = false
          this.temAnterior = false
        }
      } catch (error) {
        console.error('Erro ao carregar avaliações:', error)
        this.avaliacoes = []
        this.total = 0
        this.temProximo = false
        this.temAnterior = false
      } finally {
        this.carregando = false
      }
    },
    buscarNovamente () {
      this.page = 1
      this.carregarDados()
    },
    limparFiltros () {
      this.filtroNota = null
      this.filtroData = ''
      this.page = 1
      this.carregarDados()
    },
    limparFiltrosSilent () {
      this.filtroNota = null
      this.filtroData = ''
      this.page = 1
    },
    irParaPagina (novaPagina) {
      if (novaPagina >= 1 && novaPagina <= this.totalPages) {
        this.page = novaPagina
        this.carregarDados()
      }
    },
    formatarData (data) {
      if (!data) return ''
      try {
        const d = new Date(data.replace(/-/g, '/'))
        if (isNaN(d.getTime())) {
          return data
        }
        const dia = String(d.getDate()).padStart(2, '0')
        const mes = String(d.getMonth() + 1).padStart(2, '0')
        const ano = d.getFullYear()
        const horas = String(d.getHours()).padStart(2, '0')
        const minutos = String(d.getMinutes()).padStart(2, '0')
        return `${dia}/${mes}/${ano} ${horas}:${minutos}`
      } catch (e) {
        return data
      }
    }
  }
}
</script>

<style>
.hide-scrollbar::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}
.hide-scrollbar {
  -ms-overflow-style: none !important;
  scrollbar-width: none !important;
}
</style>
